import $ from 'jquery';

// Used in many widgets to make the whole widget clickable.
// We do not want to set an A tag on the widget because of some styling problems.
// Link target is set in "data-href" attribute, LinkController parses HTML and hooks proper click events.
export default class LinkController {
    constructor(elem) {
        this.elem = elem;
        this.linkTarget = elem.dataset.href;
        this.newWindow = 'target' in elem.dataset && elem.dataset.target === '_blank';
        this.registerClickEvent();
    }

    registerClickEvent() {
        const controllerThis = this;
        if (this.linkTarget) {
            $(this.elem)
                .find('.box-media:not(.no-link), .box-text, .box-user')
                .on('click', (event) => {
                    controllerThis.makeElementClickable(event);
                });
            if(this.elem.classList.contains('card')){
                $(this.elem).on('click', (event) => {
                    controllerThis.makeElementClickable(event);
                });
            }
        }
    }

    makeElementClickable(event){
        if (event.target.tagName.toLowerCase() !== 'a' && !event.target.classList.contains('btn')) {
            if (this.newWindow) {
                window.open(this.linkTarget, '_blank');
                console.log('opening new window');
            }
            else location.href = this.linkTarget;
            return false;
        }
        return true;
    } 

    static registerClickEventForElement(selector) {
        // $(selector).find('.has-link').each((index, elem) => {
        $(selector)
            .find('.has-link')
            .each((index, elem) => {
                new LinkController(elem); // eslint-disable-line no-new
            });
    }

    static init() {
        $(document).ready(() => {
            LinkController.registerClickEventForElement(document);
        });
    }
}
